"use client";

import { useTranslations } from "next-intl";
import FaqAccordion from "./faq-accordion";

export default function UnvanliOyuncular() {
    const t = useTranslations("helpContent");

    return (
        <FaqAccordion
            items={[
                {
                    question: t("titlesQ1"),
                    answer: (
                        <>
                            <p>
                                {t.rich("titlesA1", {
                                    b: (chunks) => <strong>{chunks}</strong>,
                                })}
                            </p>
                            <p className="mt-4">
                                <strong>{t("titlesFideHeading")}</strong>
                            </p>
                            <ul>
                                <li>{t("titleCM")}</li>
                                <li>{t("titleFM")}</li>
                                <li>{t("titleIM")}</li>
                                <li>{t("titleGM")}</li>
                            </ul>
                            <p className="mt-4">
                                <strong>{t("titlesWomenHeading")}</strong>
                            </p>
                            <ul>
                                <li>{t("titleWCM")}</li>
                                <li>{t("titleWFM")}</li>
                                <li>{t("titleWIM")}</li>
                                <li>{t("titleWGM")}</li>
                            </ul>
                        </>
                    ),
                },
            ]}
        />
    );
}
